export const HomeActionTypes = {
  TOGGLE_UPGRADE_MODAL: 'TOGGLE_UPGRADE_MODAL'
} as const
